import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=5e12fabf&"
import script from "./robot.vue?vue&type=script&lang=ts&"
export * from "./robot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports